import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { getError, InputTableFilter, SmartFormContainer } from '@shared';

@Component({
  selector: 'app-hot-search-input-filter',
  templateUrl: './hot-search-input-filter.component.html',
  styleUrls: ['./hot-search-input-filter.component.scss'],
})
export class HotSearchInputFilterComponent extends SmartFormContainer implements OnInit {
  protected readonly getError = getError;
  readonly debounceTime = 100;

  @Input() previousValue: string = '';
  @Input() config: InputTableFilter;
  @Input() initialForm: object;
  @Output() filterApplied: EventEmitter<Record<string, any>> = new EventEmitter<Record<string, any>>();
  @Output() showFilters: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatMenuTrigger) public menuTrigger: MatMenuTrigger;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  get isValueChanged(): boolean {
    return this.control.value !== this.previousValue;
  }

  onInput(event: Event): void {
    if ((event.target as HTMLInputElement).value === '') {
      this.applyFilterForm();
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  searchOnEnter(): void {
    if (!this.control.valid) {
      return;
    }
    this.applyFilterForm();
  }

  notChanged(name: string): boolean {
    return this.initialForm[name] === this.form.getRawValue()[name];
  }

  changed(name: string): boolean {
    return !this.notChanged(name);
  }

  stopPropagation(event): void {
    event.stopPropagation();
  }

  clearField(field: AbstractControl, event?: Event, value?: any): void {
    if (event) {
      event.stopPropagation();
    }
    if (field.reset) {
      if (value === '' || value === null) {
        field.reset(value);
        this.applyFilterForm();
        return;
      }
      field.reset();
    }
  }

  openFilters(): void {
    this.showFilters.emit();
  }

  applyFilterForm(): void {
    if (this.isValueChanged) {
      this.filterApplied.emit(this.form.value);
    }
  }
}
